import {
  fontSizeVars,
  lineHeightVars,
  spacingVars,
} from '@tundr/ds-foundations';
import { style } from '@vanilla-extract/css';

export const dateRangeFilterWrapperClass = style({
  alignItems: 'center',
  gap: spacingVars.md,
});

export const shortcutsRowClass = style({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: spacingVars.sm,
});

export const datesRowClass = style({
  display: 'flex',
  flexDirection: 'row',
  gap: spacingVars.sm,
});

export const dateColClass = style({
  display: 'flex',
  flexDirection: 'column',
});

const DATE_INPUT_WIDTH_PX = 160;

export const dateRangeInputClass = style({
  width: DATE_INPUT_WIDTH_PX,
});

export const dateRangeConstraintsClass = style({
  display: 'flex',
  flexDirection: 'column',
  marginTop: spacingVars.sm,
  gap: spacingVars.xs,
  fontSize: fontSizeVars.body.body2,
  lineHeight: lineHeightVars.body.body2,
});
